<!-- 上传操作 -->
<template>
    <div>
        <el-dialog title="附件" center :visible.sync="uploadDia" append-to-body width="530px">
            <!-- 
            重点关注的代码：
            :show-file-list="false"
            ref="contentWrap
        -->
            <el-upload  v-if="type != 1"  class="upload-demo" ref="uploadCom" :show-file-list="false" :action="uploadUrl()"
                :on-success="onSuccess" :before-upload="beforeUpload" multiple :limit="5" :headers='token'
                :on-exceed="handleExceed" :file-list="fileList">
                <el-button icon="el-icon-upload2" @click="uploadFileClick($event)">将文件拖到此处，或<em>点击上传</em></el-button>
                <div slot="tip" class="el-upload__tip">
                    <!-- 支持扩展名：.rar .zip .doc .docx .xls .txt .pdf .jpg .png .jpeg，最多上传5个文件，每个大小不超过50Mb-->
                    支持扩展名：.txt .pdf .jpg .png .jpeg
                </div>
            </el-upload>
            <div class="flex mt20" v-if="fileData.length > 0">
                <div class="items-wrap" ref="contentWrap" :style="wrapHeight <= 70 ? 'height: auto' : `height: 60px;`"
                    :class="{ noHidden: noHidden }">
                    <Uploadfileitem v-for="(item, index) in fileData" :key="index" :file="item" @cancel="cancelFile" 
                        :showDel="true" class="mr20"></Uploadfileitem>
                </div>
                <div class="on-off" v-if="wrapHeight > 70" @click="noHidden = !noHidden">
                    {{ noHidden ? "收起" : "更多" }}
                </div>
            </div>
            <span slot="footer" class="dialog-footer" v-if="type != 1" >
                <el-button @click="uploadDia = false">取 消</el-button>
                <el-button type="primary" @click="conRes">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Uploadfileitem from '@/components/Uploadfileitem.vue'
export default {
    name: "uploadFile",
    // props:['formData'],
    //import引入的组件需要注入到对象中才能使用
    components: {
        Uploadfileitem
    },
    data() {
        //这里存放数据
        return {
            uploadDia: false,
            reviewProcessBox: false,
            sendDataInfo: {
                state: '',
                id: ""
            },
            reviewNodeList: [],
            type: 0,

            noHidden: true,
            wrapHeight: 0,
            delDialogitem: 0,
            imgLoad: false,
            centerDialogVisible: false,
            fileList: [],
            token: {
                token: sessionStorage.getItem('token')
            },
            fileData: [],
            type: 0
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        conRes() {
            this.$emit('backData',this.fileData)
            this.uploadDia = false
        },
        delFile(id) {
            console.log(id)
        },
        handleClose() {
            this.$emit('closeFile')
        },
        uploadUrl() {
            return this.$store.getters.getConfig.imgUrl+'/upload/fileupload';
        },
        cancelFile(file) {
            console.log(file);
            this.fileData.forEach((item,index)=>{
                if (item.fileId == file.fileId) {
                    this.fileData.splice(index,1)
                }
            })
        },

        // 上传文件只能添加五条
        uploadFileClick(event) {
            // if (this.formLabelAlign.annex.length === 5) {
            //     this.$message({
            //         type: "warning",
            //         message: "最多只可以添加五条",
            //     });
            //     event.stopPropagation();
            //     return false;
            // }
        },
        //
        onSuccess(response, file, fileList) {
            console.log(response, file, fileList)
            if (!response) {
                this.$message.error("文件上传失败");
            } else {
                this.imgLoad = false;
                this.fileData.push(response.result[0])
                this.$message({
                    message: "上传成功!",
                    type: "success",
                });
            }
        },
        beforeUpload(file) {
            for (let i = 0; i < this.fileData.length; i++) {
                const v = this.fileData[i]
                if (v.fileName == file.name) {
                    this.$message({
                        type: "error",
                        message: "请勿重复上传",
                    })
                    return false
                }
            }
        },
        handleExceed(files,) {
            console.log(file);
        },
        openBox(data,type) {
            this.uploadDia = true
            this.fileData = data
            this.type = type
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() { },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.dialog_content {
    height: 50vh;
    overflow-y: auto;
}
.items-wrap {
    width: 100%;
    flex-wrap: wrap;
    display: flex;
}
</style>